const instance = 'dev';
// const instance = 'prod';

// export const BACKEND_URL = instance === 'dev' ? 'http://localhost:8000' : "https://adhesion.apas.asso.fr";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// export const OGONE_URL = instance === 'dev' ? 'https://ogone.test.v-psp.com/ncol/test/orderstandard_utf8.asp' : 'https://secure.ogone.com/ncol/prod/orderstandard_utf8.asp';
export const OGONE_URL = process.env.REACT_APP_OGONE_URL;